export default {
  name: "main_CMS",
  data() {
    return {};
  },
};
